import { render } from "./Backlink.vue?vue&type=template&id=89529fe2&scoped=true"
import script from "./Backlink.vue?vue&type=script&lang=js"
export * from "./Backlink.vue?vue&type=script&lang=js"

import "./Backlink.vue?vue&type=style&index=0&id=89529fe2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89529fe2"]])

export default __exports__